import React from 'react';
import { AllOrgsSettingsModal } from './all-orgs-settings-modal.container';
import { SettingsModal } from './settings-modal.container';
export { AllOrgsSettingsModal, SettingsModal };
export const UserMgmtSettingsModal = ({ isOpen, currentOrgId, onClose, initialTab, }) => {
    if (!isOpen)
        return null;
    if (currentOrgId === -1) {
        return (React.createElement(AllOrgsSettingsModal, { onClose: onClose, onSave: onClose, initialTab: initialTab }));
    }
    return React.createElement(SettingsModal, { onAction: onClose });
};
//# sourceMappingURL=index.js.map